'use strict';

module.exports = function($) {
	var TimelyButton = window.timelyButton;

	return {
		init: init
	};

	function init() {
		bookings();
	}

	function bookings() {
		// var TimelyBtn;
		var bookingButton;
		var eligibleForm;
		var serviceForm;
		var bookingForm;
		var eligibleRadio;
		var stiRadio;
		var serviceRadio;
		var eligibleMessage;
		var stiMessage;
		var serviceMessage;

		// set up booking button
		// TimelyBtn = new TimelyButton('acon', {
		// 		'dontCreateButton': true
		// });

		// clickable DOM element
		bookingButton = $('#bookings [data-book-button]');

		bookingButton.on('click', function(event) {
			event.preventDefault();
			TimelyBtn.start();
			// fake a loading icon, remove after a safe-ish time
			$(this).addClass('active').animate({ 'opacity': 1 }, 2500, function() {
					$(this).removeClass('active');
			});
		});

		eligibleForm = $('#bookings [data-symptoms]');
		serviceForm = $('#bookings [data-service]');
		bookingForm = $('#bookings [data-book]');

		eligibleRadio = $('#bookings input[data-radio-booking-eligible]');
		stiRadio = $('#bookings input[data-radio-booking-sti]');
		serviceRadio = $('#bookings input[data-radio-booking-service]');

		eligibleMessage	= $('#bookings [data-eligible-message]');
		stiMessage = $('#bookings [data-symptoms-message]');
		serviceMessage = $('#bookings [data-service-message]');




		// toggle visibility of elements
		eligibleRadio.on('change', function() {
			var state = $(this).val();

			if (state === 'no') {
				eligibleForm.stop().slideUp(200);
				serviceForm.stop().slideUp(200);
				bookingForm.stop().slideUp(200);
				eligibleMessage.stop().delay(300).slideDown(200);
				stiRadio.prop('checked', '');
				serviceRadio.prop('checked', '');
			}
			else {
				eligibleMessage.stop().slideUp(200);
				eligibleForm.stop().delay(300).slideDown(200);
			}
		});

		stiRadio.on('change', function() {
			var state = $(this).val();

			if (state === 'yes') {
				serviceForm.stop().slideUp(200);
				bookingForm.stop().slideUp(200);
				stiMessage.stop().delay(300).slideDown(200);
				serviceMessage.stop().slideUp(200);
				serviceRadio.prop('checked', '');
			}
			else {
				stiMessage.stop().slideUp(200);
				serviceForm.stop().delay(300).slideDown(200);
			}
		});

		serviceRadio.on('change', function() {
			var state = $(this).val();

			if (state === 'service-b') {
				bookingForm.stop().slideUp(200);
				serviceMessage.stop().delay(300).slideDown(200);
			}
			else {
				serviceMessage.stop().slideUp(200);
				bookingForm.stop().delay(300).slideDown(200);
			}
		});
	}
};
